import { render } from "./TheFeature.vue?vue&type=template&id=5991e76e&scoped=true"
const script = {}

import "./TheFeature.vue?vue&type=style&index=0&id=5991e76e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5991e76e"]])

export default __exports__